import React from 'react';
import ColataShell from '../../components/colata/ColataShell';
import DashboardStatistiche from './components/DashboardStatistiche';

// /colata-statistiche — analisi degli interventi per zona, ricambio, anno, articolo e causa
const ColataStatistichePage = () => (
  <ColataShell indietroA="/colata-inventory">
    <DashboardStatistiche />
  </ColataShell>
);

export default ColataStatistichePage;
